"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../../../common/Icon"));

var _Select = _interopRequireDefault(require("../../../common/Select"));

var _Button = _interopRequireDefault(require("../../../common/Button"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _connectToMedia = _interopRequireDefault(require("../../Media/connectToMedia"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var searchTranscript = function searchTranscript(term, transcript) {
  return transcript.reduce(function (acc, word, i, words) {
    var termWords = term.split(" "); // query.match(/(\w+'\w+)|\w+|,|\.|!|\?/g);

    var wordsMatch = termWords.every(function (qWord, j) {
      // Check if words match raw
      if (words[i + j] && qWord.toLowerCase() === words[i + j].w.toLowerCase() // || words[i + j].w.toLowerCase().includes(qWord.toLowerCase())
      ) {
        return true;
      } // If this word is punctation, and the last ends in it, ignore it.


      if (words[i + j] && words[i + j].m === "punc" && qWord[i - 1] && words[i + j].w === qWord.charAt(qWord.length - 1)) {
        return true;
      } // Otherwise, match if the next word is punctuation and the last character matches it.


      if (words[i + j + 1] && words[i + j + 1].m === "punc" && qWord.substr(0, qWord.length - 1).toLowerCase() === words[i + j].w.toLowerCase() && words[i + j + 1].w === qWord.charAt(qWord.length - 1)) {
        return true;
      }
    }); // Pass word position for more accurate highlight animation

    if (wordsMatch) {
      acc.push({
        s: word.s,
        p: word.p
      });
    }

    return acc;
  }, []);
};

var Index = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Index, _React$PureComponent);

  function Index(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "getSearchQueryValues", (0, _memoizeOne["default"])(function (queries) {
      return queries.filter(function (query) {
        return query.type === "search";
      }).map(function (query) {
        return query.parent;
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "getSearchQueryHits", (0, _memoizeOne["default"])(function (_ref) {
      var _ref2;

      var queries = _ref.queries,
          _ref$reverse = _ref.reverse,
          reverse = _ref$reverse === void 0 ? false : _ref$reverse;
      return (_ref2 = []).concat.apply(_ref2, queries.filter(function (query) {
        return query.type === "search";
      }).map(function (query) {
        return query.hits;
      })).sort(function (a, b) {
        if (reverse) {
          return a.s > b.s ? -1 : 1;
        }

        return a.s < b.s ? -1 : 1;
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "skipToNextHit", function (event) {
      var _this$props = _this.props,
          queries = _this$props.queries,
          currentTime = _this$props.currentTime,
          currentPosition = _this$props.currentPosition,
          onSeek = _this$props.onSeek,
          onSkipPrevNextHit = _this$props.onSkipPrevNextHit;

      var searchQueryHits = _this.getSearchQueryHits({
        queries: queries
      }); // Check hit by position for more accurate positioning


      var hit = searchQueryHits.find(function (hit) {
        return hit.p > Math.ceil(currentPosition);
      }) || searchQueryHits[0];

      if (hit) {
        _this.removeWordSearchedClass();

        _this.addWordSearchedClass(hit.p);

        onSeek(hit);
        onSkipPrevNextHit(true);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "skipToPrevHit", function (event) {
      var _this$props2 = _this.props,
          queries = _this$props2.queries,
          currentTime = _this$props2.currentTime,
          currentPosition = _this$props2.currentPosition,
          onSeek = _this$props2.onSeek,
          onSkipPrevNextHit = _this$props2.onSkipPrevNextHit;

      var searchQueryHits = _this.getSearchQueryHits({
        queries: queries,
        reverse: true
      }); // Check hit by position for more accurate positioning


      var hit = searchQueryHits.find(function (hit) {
        return hit.p < Math.floor(currentPosition);
      }) || searchQueryHits[0];

      if (hit) {
        _this.removeWordSearchedClass();

        _this.addWordSearchedClass(hit.p);

        onSeek(hit);
        onSkipPrevNextHit(true);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (newSearchValues) {
      var _this$props3 = _this.props,
          onRemoveQuery = _this$props3.onRemoveQuery,
          onAddQuery = _this$props3.onAddQuery,
          _this$props3$queries = _this$props3.queries,
          queries = _this$props3$queries === void 0 ? [] : _this$props3$queries,
          transcript = _this$props3.transcript;

      var searchValues = _this.getSearchQueryValues(queries);

      _this.setState({
        searchValue: newSearchValues
      });

      (0, _lodash.difference)(newSearchValues, searchValues).forEach(function (value) {
        onAddQuery({
          parent: value,
          hits: searchTranscript(value, transcript),
          label: value,
          icon: "search",
          type: "search"
        });
      });
      (0, _lodash.difference)(searchValues, newSearchValues).forEach(function (value) {
        _this.removeWordSearchedClass();

        onRemoveQuery(value);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onRemove", function () {
      var _this$props4 = _this.props,
          onRemoveQuery = _this$props4.onRemoveQuery,
          onAddQuery = _this$props4.onAddQuery,
          _this$props4$queries = _this$props4.queries,
          queries = _this$props4$queries === void 0 ? [] : _this$props4$queries,
          transcript = _this$props4.transcript;

      var searchValues = _this.getSearchQueryValues(queries);

      _this.setState({
        searchValue: ""
      });

      (0, _lodash.difference)([], searchValues).forEach(function (value) {
        onAddQuery({
          parent: value,
          hits: searchTranscript(value, transcript),
          label: value,
          icon: "search",
          type: "search"
        });
      });
      (0, _lodash.difference)(searchValues, []).forEach(function (value) {
        onRemoveQuery(value);
      });

      _this.setState({
        hitIndex: 0
      });

      _this.removeWordSearchedClass();
    });

    _defineProperty(_assertThisInitialized(_this), "addWordSearchedClass", function (i) {
      if (document.querySelector(".word-index-" + i)) {
        document.querySelector(".word-index-" + i).classList.add("word-searched");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "removeWordSearchedClass", function () {
      var allElements = document.querySelectorAll(".word-searched");
      allElements.forEach(function (element) {
        element.classList.remove("word-searched");
      });
    });

    _this.state = {
      searchValue: "",
      hitIndex: 0,
      closeColor: "#677791"
    };
    return _this;
  }

  var _proto = Index.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props$queries = this.props.queries,
        queries = _this$props$queries === void 0 ? [] : _this$props$queries;
    var searchValues = this.getSearchQueryValues(queries);
    var hitCount = queries.reduce(function (acc, query) {
      return (0, _lodash.get)(query, "hits.length", 0) + acc;
    }, 0);
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        paddingLeft: "10px",
        paddingBottom: "25px",
        background: "rgb(255, 255, 255)",
        flex: "none"
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "flex",
        flexWrap: "none",
        alignItems: "center",
        background: "#f0f1f4"
      },
      className: "search-input-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      id: "search-field",
      style: {
        padding: "0 0px",
        width: "80%"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
      size: "small",
      style: {
        width: "100%"
      },
      dropdownStyle: {
        display: "none"
      },
      tags: true,
      tokenSeparators: ["|"],
      suffixIcon: /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        type: "search"
      }),
      placeholder: "Find words in the transcript",
      defaultValue: searchValues,
      onChange: this.onChange,
      value: searchValues,
      showSearch: true
    }), /*#__PURE__*/_react["default"].createElement("svg", {
      width: "21",
      height: "21",
      viewBox: "0 0 21 21",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.13379 16.5439C12.7582 16.5439 15.6963 13.6058 15.6963 9.98145C15.6963 6.35708 12.7582 3.41895 9.13379 3.41895C5.50942 3.41895 2.57129 6.35708 2.57129 9.98145C2.57129 13.6058 5.50942 16.5439 9.13379 16.5439Z",
      stroke: "#677791",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13.7739 14.6221L17.5708 18.419",
      stroke: "#677791",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        flex: "none"
      }
    }, !(0, _lodash.isEmpty)(this.state.searchValue) &&
    /*#__PURE__*/
    // <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    // <path d="M3 10L8 5L13 10" stroke="#677791" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    // </svg>
    _react["default"].createElement(_Button["default"], {
      shape: "none",
      size: "sm",
      onClick: this.skipToPrevHit,
      icon: "up",
      disabled: hitCount == 0,
      style: {
        border: "none",
        height: "32px",
        marginTop: "1px",
        borderRadius: "0px",
        background: "#f0f1f4"
      }
    })), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        padding: "0 0px",
        flex: "none"
      }
    }, !(0, _lodash.isEmpty)(this.state.searchValue) && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      shape: "none",
      size: "sm",
      onClick: this.skipToNextHit,
      icon: "down",
      disabled: hitCount == 0,
      style: {
        border: "none",
        height: "32px",
        marginTop: "1px",
        background: "#f0f1f4",
        borderRadius: "0px"
      }
    })), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        padding: "0 0px",
        flex: "none"
      },
      className: "close-content"
    }, !(0, _lodash.isEmpty)(this.state.searchValue) &&
    /*#__PURE__*/
    //   <Button
    //     shape="none"
    //     size="sm"
    //     onClick={this.skipToNextHit}
    //     icon="down"
    //     disabled={hitCount == 0}
    //   />
    _react["default"].createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: "close-icon",
      onClick: function onClick() {
        return _this2.onRemove();
      },
      onMouseOver: function onMouseOver() {
        return _this2.setState({
          closeColor: "#262D38"
        });
      },
      onMouseLeave: function onMouseLeave() {
        return _this2.setState({
          closeColor: "#677791"
        });
      }
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12.5 3.5L3.5 12.5",
      stroke: this.state.closeColor,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12.5 12.5L3.5 3.5",
      stroke: this.state.closeColor,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })))));
  };

  return Index;
}(_react["default"].PureComponent);

Index.propTypes = process.env.NODE_ENV !== "production" ? {} : {};

var _default = (0, _connectToMedia["default"])(function (state) {
  return {
    currentTime: state.media.currentTime,
    currentPosition: state.media.currentPosition,
    skipPrevNextHit: state.media.skipPrevNextHit,
    queries: state.query
  };
})(Index);

exports["default"] = _default;